import { BaseModel, convertToArrayModels, fillOwnProperties } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'
import LandingImagesItem from './LandingImagesItem'

export default class LandingImagesBlock extends BaseModel {
  static override constructorName = 'LandingImagesBlock'

  readonly name = 'images_block'

  title: string = ''
  items: LandingImagesItem[] = []
  'background_image': string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['items', 'background_image'])

      this.items = convertToArrayModels(data.items, LandingImagesItem)
      this.background_image = toCroppedImage(data.background_image)
    }
  }
}
